<template>
    <div class="row justify-content-center">
        <div class="col-md-8">
            <div style="padding: 0 5px 20px 5px;">
                <div class="accordion" id="accordionExample">
                    <div class="accordion-item">
                        <h2 class="accordion-header" id="headingOne">
                            <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                Как сгенерировать свою картину ?
                            </button>
                        </h2>
                        <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne"
                             data-bs-parent="#accordionExample">
                            <div class="accordion-body">
                                Ниже вы видите фотографию кота. Да, мы решили использовать именно эту наглую морду =))
                                Вы можете увеличить или уменьшить картинку и перемещать ее для выбора нужной области.
                                Выберите ту часть фотографии, по которой вы хотите нарисовать картину.
                                Ниже вы можете загрузить фотографию из своей медиотеки, и это может быть рисунок или
                                набросок, а не только фотография, не ограничивайте себя выбором.
                                Генерируйте картину пока не получите желаемый результат.
                            </div>
                        </div>
                    </div>
                    <div class="accordion-item">
                        <h2 class="accordion-header" id="headingTwo">
                            <button @click="counter += 1" class="accordion-button collapsed" type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                Какие фотографии выбирать ?
                            </button>
                        </h2>
                        <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo"
                             data-bs-parent="#accordionExample">
                            <div class="accordion-body">
                                Выбирайте достаточно контрастные фотографии. Не отдаляйте изображение, разрешение
                                картины 77*77 ячеек, поэтому стоит максимально крупно помещать лица людей, животных,
                                парные фотографии. Избегайте на фотографии больших участков одного цвета, хотя в
                                некоторых случая они придуют изюминку.
                            </div>
                        </div>
                    </div>
                    <div class="accordion-item">
                        <h2 class="accordion-header" id="headingThree">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                Где взять код ?
                            </button>
                        </h2>
                        <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree"
                             data-bs-parent="#accordionExample">
                            <div class="accordion-body">
                                В вашем наборе, на обратной стороне холста, расположен qr-code. Сканируйте его и
                                переходите на страницу, где вы можете скопировать код для генерации картины на другом
                                устройстве, или сразу перейти на эту страницу.
                                Как только вы нажмете кнопку "Получить схему для картины", код будет использован и вы
                                сможете загрузить pdf инструкцию. Не волнуйтесь, вы всегда сможете вернуться к ней введя
                                код на этой странице или после перехода по qr-code в вашем наборе. Приятного
                                времяприпровождения.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <cropper id="cropper" style="width: 100%; aspect-ratio: 1 / 1; padding-top: 20px;"
                     ref="cropper"
                     :src="crop_img"
                     :auto-zoom="true"
                     :stencil-props="{
                                handlers: {},
                                movable: false,
                                scalable: false,
                                aspectRatio: aspectRatio,
                            }"
                     :resize-image="{adjustStencil: false}"
                     image-restriction="stencil"

            />
            <div class="row justify-content-between align-items-end" style="padding: 30px 0 30px 0;">
                <div class="col-lg-6 col-sm-12" style="margin-top: 10px;">
                    <div class="selected_color">
                        <label for="formFile" class="form-label">Загрузите вашу картинку (макс 15Мб)</label>
                        <input class="form-control" type="file" id="formFile" accept="image/jpeg"
                               @change="changeImgCrop">
                    </div>
                </div>
                <div class="col-lg-6 col-sm-12 text-center" style="margin-top: 10px;">
                    <button @click="crop" type="button" class="btn btn-outline-secondary selected_color">
                        Посмотреть результат
                    </button>
                </div>
            </div>
            <div style="padding-bottom: 20px; aspect-ratio: 100/35;">
                <transition name="slide-fade">
                    <div v-if="show_result" class="row justify-content-evenly">
                        <div class="col-lg-4 col-md-5 col-6">
                            <img :src="a1_src" style="width: 100%; border: solid 4px lightgray">
                            <div class="form-check form-check-inline d-flex justify-content-center"
                                 style="padding: 15px">
                                <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1"
                                       value="v1" v-model="check_img">
                                <label class="form-check-label" for="inlineRadio1" style="padding-left: 10px">Рисую эту
                                    картину !</label>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-5 col-6">
                            <img :src="m1_src" style="width: 100%; border: solid 4px lightgray">
                            <div class="form-check form-check-inline d-flex justify-content-center"
                                 style="padding: 15px">
                                <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2"
                                       value="v2" v-model="check_img">
                                <label class="form-check-label" for="inlineRadio2" style="padding-left: 10px">Нет эту
                                    !</label>
                            </div>
                        </div>
                    </div>
                </transition>
                <div class="d-grid gap-2" style="padding-bottom: 20px;" v-if="show_result">
                    <button class="btn btn-primary" type="button" @click="route_to_pdf">
                        Получить инструкцию
                    </button>
                </div>
            </div>

            <!-- Модальное окно -->
            <div class="modal fade" ref="exampleModal" tabindex="-1" aria-hidden="true">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel">{{modal_title}}</h5>
                            <button type="button" class="btn-close" @click="modal.hide()" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                            {{modal_body}}
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-primary" v-show="show_btn_to_pdf"
                                    @click="route_to_pdf_page">
                                Получить инструкцию
                            </button>
                            <button type="button" class="btn btn-secondary" @click="modal.hide()">Закрыть</button>
                        </div>
                    </div>
                </div>
            </div>

            <div id="pl" v-if="show_spinner">
                <grid-loader class="sp" :loading="true" color="blue"></grid-loader>
            </div>
        </div>
    </div>
</template>

<script>
    import {Cropper} from "vue-advanced-cropper";
    import {Modal} from 'bootstrap'
    import "vue-advanced-cropper/dist/style.css";
    import img_preview from "@/img/preview.jpg";

    import GridLoader from 'vue-spinner/src/GridLoader.vue'

    export default {
        name: "QrCodeGenerateN",
        components: {
            Cropper,
            GridLoader
        },
        data() {
            return {
                crop_img: img_preview,
                aspectRatio: 1,
                show_spinner: false,
                show_result: false,
                a1_src: null,
                m1_src: null,
                qr_code: null,
                check_img: null,
                modal: null,
                modal_title: null,
                modal_body: null,
                show_btn_to_pdf: false,
            }
        },
        methods: {
            async check_code() {
                try {
                    this.qr_code = this.$route.params.qr_code;
                    this.show_spinner = true;
                    this.check_img = null;
                    const response = await
                        this.$axios.post('/qr_code_check',
                            {
                                qr_code: this.qr_code,
                            });

                    let res_check = response.data.res_check;
                    if (res_check === 'error') {
                        this.$router.push('/qr_code');
                    } else if (res_check === 'ok') {
                        console.log('ok');
                    } else if (res_check === 'pdf') {
                        this.$router.push('/instruction/' + this.qr_code);
                    }

                    this.show_spinner = false;
                } catch (e) {
                    console.log(e);
                    this.show_spinner = false;
                }
            },
            async crop() {
                const {canvas} = this.$refs.cropper.getResult();
                const imgURL = canvas.toDataURL();

                try {
                    this.show_result = false;
                    this.show_spinner = true;
                    this.check_img = null;
                    const response = await
                        this.$axios.post('/generation_img',
                            {
                                imgURL: imgURL,
                                qr_code: this.qr_code,
                            });

                    let res_check = response.data.res_check;
                    if (res_check === 'error') {
                        this.$router.push('/qr_code');
                    } else if (res_check === 'pdf') {
                        this.$router.push('/instruction/' + this.qr_code);
                    } else {
                        this.a1_src = `data:image/jpeg;base64,${response.data.imgs[0]}`;
                        this.m1_src = `data:image/jpeg;base64,${response.data.imgs[1]}`;

                        this.show_result = true;
                    }

                    this.show_spinner = false;
                } catch (e) {
                    console.log(e);
                    console.log('Ошибка передачи файла');
                    this.show_spinner = false;
                }
            },
            changeImgCrop(e) {
                const image = e.target.files[0];
                // Проверка на размер
                if (image.size > 15 * 1024 * 1024) {
                    alert('Слишком большой файл');
                    return
                }
                const reader = new FileReader();
                reader.readAsDataURL(image);
                reader.onload = e => {
                    this.crop_img = e.target.result;
                };
            },
            route_to_pdf() {
                this.show_btn_to_pdf = false;
                if (this.check_img === null) {
                    this.modal_title = 'Выберите картину';
                    this.modal_body = 'Выберите картину, которая вам больше понравилась по контрасту.';
                } else {
                    this.modal_title = 'Вы уверены в выборе ?';
                    this.modal_body = 'После того как вы нажмете по кнопке "Получить инструкцию", ' +
                        'вы перейдете на страницу с инструкциее. В последующем выбор невозможно будет изменить.' +
                        'Вы всегда сможете перейти на страницу с инструкцией по qr-code из ' +
                        'вашего набора или указав код на этой странице.';
                    this.show_btn_to_pdf = true;
                }
                this.modal.show();
            },
            async route_to_pdf_page() {
                try {
                    this.show_result = false;
                    this.show_spinner = true;

                    const response = await
                        this.$axios.post('/generation_choice_img',
                            {
                                v_img: this.check_img,
                                qr_code: this.qr_code,
                            });

                    let res_check = response.data.res_check;
                    if (res_check === 'error') {
                        this.modal.hide();
                        this.$router.push('/qr_code');
                    } else {
                        this.modal.hide();
                        this.$router.push('/instruction/' + this.qr_code);
                    }

                    this.show_spinner = false;
                    this.show_result = true;
                } catch (e) {
                    console.log(e);
                    console.log('Ошибка передачи файла');
                    this.show_spinner = false;
                }
            }
        },
        created() {
            this.check_code();
        },
        mounted() {
            this.modal = new Modal(this.$refs.exampleModal);
        }
    }
</script>

<style scoped>

</style>